import { useEffect, useState } from 'react';

import useMartyContext from 'hooks/useMartyContext';
import { fetchErrorMiddleware } from 'middleware/fetchErrorMiddleware';
import { getReviewSummarization } from 'apis/reviewSummarization';
import type { ReviewSummarizationResponse } from 'types/reviewSummarization';

interface UseFetchReviewSummarizationParams {
  fetch?: typeof getReviewSummarization;
  productId: string;
}

export const useFetchReviewSummarization = ({ fetch = getReviewSummarization, productId }: UseFetchReviewSummarizationParams) => {
  const { environmentConfig: { api: { reviewSummary: { url: reviewSummaryUrl = '' } = {} } = {} } = {} } = useMartyContext();
  const [reviewSummarization, setReviewSummarization] = useState<ReviewSummarizationResponse>();
  const [isFetched, setIsFetched] = useState(false);

  useEffect(() => {
    if (!reviewSummaryUrl) {
      return;
    }

    const controller = new AbortController();

    const fetchReviewSummarization = async () => {
      try {
        const response = await fetch({
          reviewSummaryUrl,
          controller,
          productId
        });

        const reviewSummarization: ReviewSummarizationResponse = await fetchErrorMiddleware(response);
        if (!reviewSummarization) {
          return;
        }
        setReviewSummarization(reviewSummarization);
        setIsFetched(true);
      } catch (e) {
        setIsFetched(true);
        return;
      }
    };

    fetchReviewSummarization();

    return () => {
      controller.abort();
    };
  }, [reviewSummaryUrl]);

  return { reviewSummarization, isFetched };
};
